export const institutionsRoutePaths = {
  list: {
    path: 'institutions',
    fullPath: '/institutions',
  },
  divergences: {
    path: 'institutions/divergences',
    fullPath: '/institutions/divergences',
  },
  detail: {
    // 식별자 = cik 10자리 문자열(backend 계약서 확정 2026-10-02). (TRAD-3582)
    path: 'institutions/:cik',
    fullPath: (cik: string) => `/institutions/${cik}`,
  },
} as const;
